import { Environment } from '~/types/Environments'

export const useEnvironment = () => {
  const { hostname } = useRequestURL()

  const isProduction = computed(() => hostname === Environment.production)
  const isDevelopment = computed(() => hostname === Environment.development)
  const isLocal = computed(() => hostname === Environment.local)
  const isTest = computed(() => hostname === Environment.test)
  const isAcceptance = computed(() => hostname === Environment.acceptance)

  const environment = computed(() => {
    if (isProduction.value) return Environment.production
    if (isDevelopment.value) return Environment.development
    if (isLocal.value) return Environment.local
    if (isTest.value) return Environment.test
    if (isAcceptance.value) return Environment.acceptance
    return Environment.local
  })

  return {
    isProduction,
    isDevelopment,
    isLocal,
    isTest,
    isAcceptance,
    environment,
  }
}
